import React from 'react';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  EmailIcon,
} from 'react-share';
import { Slides, Slide, Image, Info, Share } from './Slideshow.style';

const settings = {
  arrows: true,
  dots: false,
  variableWidth: true,
  centerMode: true,
  speed: 500,
  slidesToShow: 1,
  infinite: false,
};

const Slideshow = ({ title, images }) => {
  const windowGlobal = typeof window !== 'undefined' && window;

  return (
    <Slides {...settings}>
      <Slide>
        <Info>
          <hgroup>
            <h3>{title}</h3>
            <h4>Slideshow</h4>
          </hgroup>
          <hr />
          <p>{images.length} afbeeldingen</p>
        </Info>
      </Slide>
      {images.map(image => (
        <Slide key={image.id}>
          {image && image.localFile && (
            <Image>
              <source
                srcSet={image.localFile.childImageSharp.fluid.srcSetWebp}
                type="image/webp"
              />
              <source
                srcSet={image.localFile.childImageSharp.fluid.srcSet}
                type="image/jpeg"
              />
              <img
                src={image.localFile.childImageSharp.fluid.src}
                alt={image.alt_text}
                loading="lazy"
              />
            </Image>
          )}
        </Slide>
      ))}
      <Slide>
        <Share>
          <h3>Vertel het verder</h3>
          <p>
            Tot zover van dit artikel genoten? Deel het dan op social media.
          </p>
          <div>
            <FacebookShareButton url={windowGlobal?.location?.href}>
              <FacebookIcon size={60} round />
            </FacebookShareButton>
            <TwitterShareButton url={windowGlobal?.location?.href}>
              <TwitterIcon size={60} round />
            </TwitterShareButton>
            <WhatsappShareButton url={windowGlobal?.location?.href}>
              <WhatsappIcon size={60} round />
            </WhatsappShareButton>
            <EmailShareButton url={windowGlobal?.location?.href}>
              <EmailIcon size={60} round />
            </EmailShareButton>
          </div>
        </Share>
      </Slide>
    </Slides>
  );
};

export default Slideshow;
